import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FormRow, StyledCheckbox, StyledInput } from '@ui/Form';
import { containerClassNames, inputContainerClassNames, labelClassNames } from '~/components/ui/Form/StyledInput';
import { TableField } from './TableField';

const weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

const timeOptions = Array.from({ length: 25 }, (_, i) => String(i).padStart(2, '0') + ':00');

const Select = ({ label, name, value, onChange, children }) => (
    <div className={containerClassNames({ fullWidth: true })}>
        <label htmlFor={'table_' + name} className={labelClassNames()}>
            {label}
        </label>
        <div className={inputContainerClassNames({ bordered: true, className: 'tw-pr-2' })}>
            <select
                id={'table_' + name}
                name={name}
                value={value}
                onChange={onChange}
                className="tw-h-full tw-w-full tw-flex-1 tw-cursor-pointer tw-border-none tw-bg-transparent tw-text-sm tw-outline-none"
            >
                {children}
            </select>
        </div>
    </div>
);

export const TableFieldAssistant = ({ values, setValues, withoutDisabledTimes = false, withoutMinimums = false }) => {
    const setDisabledTimes = (disabledTimes) => {
        setValues({
            ...values,
            disabledTimes
        });
    };

    const getRows = (startTime = values.startTime, endTime = values.endTime, period = values.period) => {
        let rows = [];
        let hoursStart = startTime.split(':')[0];
        let hoursEnd = endTime.split(':')[0];
        for (let i = Number(hoursStart); i < Number(hoursEnd); i++) {
            for (let p = 0; p < Number(period); p++) {
                let hours = String(i);
                let timeSlice = (60 / Number(period)) * p;

                if (hours.length === 1) {
                    hours = '0' + hours;
                }

                rows.push(hours + ':' + (timeSlice === 0 ? '00' : timeSlice));
            }
        }

        return rows;
    };

    const updateTable = (e) => {
        let newValues = { ...values, [e.target.name]: e.target.value };
        setValues({
            ...newValues,
            rows: getRows(newValues.startTime, newValues.endTime, newValues.period)
        });
    };

    const toggleWeekday = (wd, checked) => {
        const selected = values.weekdays ?? [];
        const next = checked ? [...selected.filter((s) => s !== wd), wd] : selected.filter((s) => s !== wd);
        setValues({ ...values, weekdays: next.sort((a, b) => weekdays.indexOf(a) - weekdays.indexOf(b)) });
    };

    return (
        <div className="tw-mb-4 tw-flex tw-flex-col tw-gap-3">
            <FormRow>
                <Select
                    label="Tägliche Startzeit"
                    name="startTime"
                    value={values.startTime || '00:00'}
                    onChange={updateTable}
                >
                    {timeOptions.map((o) => (
                        <option key={o} value={o}>
                            {o}
                        </option>
                    ))}
                </Select>
                <Select
                    label="Tägliche Endzeit"
                    name="endTime"
                    value={values.endTime || '00:00'}
                    onChange={updateTable}
                >
                    {timeOptions.map((o) => (
                        <option key={o} value={o}>
                            {o}
                        </option>
                    ))}
                </Select>
            </FormRow>
            <Select label="Zeiteinteilung" name="period" value={values.period || '1'} onChange={updateTable}>
                <option value="1">Stündlich</option>
                <option value="2">Halbstündlich</option>
            </Select>
            <div>
                <span className={labelClassNames({ className: 'tw-mb-2' })}>
                    An welchen Tagen findet das Training statt?
                </span>
                <div className="tw-flex tw-flex-wrap tw-gap-x-5 tw-gap-y-2 tw-pl-1">
                    {weekdays.map((wd) => (
                        <StyledCheckbox
                            key={wd}
                            id={'table_weekday_' + wd}
                            isSelected={values.weekdays ? values.weekdays.includes(wd) : false}
                            onChange={(checked) => toggleWeekday(wd, checked)}
                        >
                            {wd}
                        </StyledCheckbox>
                    ))}
                </div>
            </div>
            {!withoutMinimums && (
                <FormRow>
                    <StyledInput
                        bordered
                        fullWidth
                        type="number"
                        min={0}
                        name="minTimes"
                        label="Mindestanzahl Zeiten"
                        value={values.minTimes ?? ''}
                        onChange={(e) => setValues({ ...values, minTimes: e.target.value })}
                    />
                    <StyledInput
                        bordered
                        fullWidth
                        type="number"
                        min={0}
                        name="minDays"
                        label="Mindestanzahl verschiedener Tage"
                        value={values.minDays ?? ''}
                        onChange={(e) => setValues({ ...values, minDays: e.target.value })}
                    />
                </FormRow>
            )}
            {!withoutDisabledTimes && (
                <TableField
                    selectIcon={faTimes}
                    field={{
                        label: 'Gesperrte Zeiten',
                        rows: values.rows,
                        columns: values.weekdays,
                        rules: []
                    }}
                    values={values.disabledTimes}
                    cb={setDisabledTimes}
                />
            )}
        </div>
    );
};
